// test845
(845 && 0);
